import { useQuery } from '@apollo/client';

import { type StatusChartFilter } from '@/app/[locale]/(authorized)/(dashboard)/components/Dashboard/components/Charts/components/StatusChart/components/StatusChartFilter';
import StatusChart from '@/graphql/dashboard/StatusChart';
import { useCommonApolloOptions } from '@/hooks/use-common-apollo-options';
import { type Defined } from '@/types/common';

import type { StatusChartQuery } from '../../../../../../../../../../generated/graphql';

type UseStatusChartOptions = {
  filter?: StatusChartFilter;
};

export type StatusChartData = Defined<StatusChartQuery['dashboardWidgetsStatusChartV2']>;

export function useStatusChartData(options: UseStatusChartOptions) {
  const { filter } = options;

  const apolloOptions = useCommonApolloOptions();

  return useQuery(StatusChart, {
    ...apolloOptions,
    variables: filter
      ? {
          period: filter.period,
          currency_id: filter.currency.id,
          operation_type: filter.operationType,
          gate_group_id: filter.gateGroup?.id || undefined,
        }
      : undefined,
    skip: !filter,
  });
}
